module.exports = __webpack_public_path__ + "img/datahub-2.721f5ece.png";